import { assistantConversationId, assistantMessageId } from "@inrev/common";
import * as z from "zod";
import * as AgentTurn from "./agent/turn";
import { CHAR_LIMIT } from "./message";
import { timeZoneSchema } from "./time-zone";

export namespace Request {
	export const schema = z.object({
		message: z.string().min(1).max(CHAR_LIMIT),
		timeZone: timeZoneSchema,
	});
}
export type Request = z.infer<typeof Request.schema>;

export namespace DoneEvent {
	export const schema = z.object({
		type: z.literal("done"),
		conversationId: assistantConversationId,
		messageId: assistantMessageId,
		seq: z.number().int(),
	});
}
export type DoneEvent = z.infer<typeof DoneEvent.schema>;

export namespace Event {
	export const schema = z.discriminatedUnion("type", [
		AgentTurn.TextDeltaEvent.schema,
		AgentTurn.ToolCallEvent.schema,
		AgentTurn.ToolResultEvent.schema,
		AgentTurn.UsageEvent.schema,
		AgentTurn.ErrorEvent.schema,
		DoneEvent.schema,
	]);
}
export type Event = z.infer<typeof Event.schema>;
